// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.availability-price-selector[data-v-3bfebffd] {
  margin-bottom: 15px;
}
.availability-price-selector__option[data-v-3bfebffd] {
  background: #fff;
  border: 1px solid #504f4d;
  color: #504f4d;
  font-family: "Gotham A", "Gotham B", sans-serif;
  font-size: 11px;
  margin-right: 6px;
  padding: 8px 10px;
  text-transform: uppercase;
}
.availability-price-selector__option--active[data-v-3bfebffd] {
  background: #504f4d;
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./public/frontend/src/AvailabilityPriceSelector.vue","webpack://./AvailabilityPriceSelector.vue"],"names":[],"mappings":"AACA;EACI,mBAAA;ACAJ;ADGA;EACI,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,+CAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,yBAAA;ACDJ;ADIA;EACI,mBAAA;EACA,WAAA;ACFJ","sourcesContent":["\n.availability-price-selector {\n    margin-bottom: 15px;\n}\n\n.availability-price-selector__option {\n    background: #fff;\n    border: 1px solid #504f4d;\n    color: #504f4d;\n    font-family: \"Gotham A\", \"Gotham B\", sans-serif;\n    font-size: 11px;\n    margin-right: 6px;\n    padding: 8px 10px;\n    text-transform: uppercase;\n}\n\n.availability-price-selector__option--active {\n    background: #504f4d;\n    color: #fff;\n}\n",".availability-price-selector {\n  margin-bottom: 15px;\n}\n.availability-price-selector__option {\n  background: #fff;\n  border: 1px solid #504f4d;\n  color: #504f4d;\n  font-family: \"Gotham A\", \"Gotham B\", sans-serif;\n  font-size: 11px;\n  margin-right: 6px;\n  padding: 8px 10px;\n  text-transform: uppercase;\n}\n.availability-price-selector__option--active {\n  background: #504f4d;\n  color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
